import { render, staticRenderFns } from "./SuppliersBookingSettingsBookings.vue?vue&type=template&id=f3240dec&"
import script from "./SuppliersBookingSettingsBookings.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettingsBookings.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersBookingSettingsBookings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports